import { memo } from "react";
import cn from "classnames";

import TabDetails from "./TabDetails";

import IconWrap from "components/ui/Icons";

import { useViews } from "utils/useViews";

import { View } from "store/window/types";

import "./style.scss";

const WindowTab = memo((props: WindowTabProps) => {
    const { name, containerName, active, close, splitView, onClose, onActivate, onSync } = props;

    const views = useViews({ containerName });

    const view = views.find((view: View) => view.name === name) || {};

    const tabClassNames = cn("no-scroll window-tab", {
        home: name === "Home",
        active: active,
        "split-view": splitView,
    });

    const renderSplitViewTab = () => {
        const { isSplitViewSync } = view;

        return (
            <div key={name} className={tabClassNames}>
                <div className="flex-row align-center fill-height">
                    <TabDetails containerName={containerName} name={name} side="left" onActivate={() => onActivate(name)} />
                    <div className="fill-height no-shrink split-view-sync-controls">
                        <IconWrap
                            icon={isSplitViewSync ? "locked cut-scissors-filled" : "copy-link"}
                            title={isSplitViewSync ? "Unsynchronize" : ""}
                            noBackground
                            onClick={() => onSync(name)}
                        />
                        <IconWrap
                            icon={isSplitViewSync ? "locked copy-link" : "copy-link"}
                            title={isSplitViewSync ? "" : "Synchronize"}
                            noBackground
                            onClick={() => onSync(name)}
                        />
                    </div>
                    <TabDetails
                        containerName={containerName}
                        name={name}
                        side="right"
                        onClose={close ? onClose : undefined}
                        onActivate={() => onActivate(name)}
                    />
                </div>
            </div>
        );
    };

    const renderDefaultTab = () => {
        return (
            <div key={name} className={tabClassNames}>
                <TabDetails containerName={containerName} name={name} onClose={close ? onClose : undefined} onActivate={onActivate} />
            </div>
        );
    };

    return splitView ? renderSplitViewTab() : renderDefaultTab();
});

interface WindowTabProps {
    /**
     * Name of the View.
     */
    name: string;

    /**
     * Type of View's container.
     */
    containerName: string;

    /**
     * View is active.
     */
    active?: boolean;

    /**
     * View can be closed.
     */
    close?: boolean;

    /**
     * Split view active for the View.
     */
    splitView?: boolean;

    /**
     * Function that closes a View.
     */
    onClose: (name: string) => void;

    /**
     * Function that activates a View.
     */
    onActivate: (name: string) => void;

    /**
     * Function that enables/disables
     * sync scrolling for Split View.
     */
    onSync: (name: string) => void;
}

export default WindowTab;
